import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { RootState } from 'store';
import { ImportSessionStorage } from 'utils/importSessionStorage';

interface Props {
  children: React.ReactNode;
}
const AuthRoute = ({ children }: Props) => {
  const navigate = useNavigate();
  // In cookie mode, check for user data instead of token
  const token = useSelector((state: RootState) => state.auth.token);
  const user = useSelector((state: RootState) => state.auth.user);
  const isAuthenticated = token || user;

  useEffect(() => {
    if (isAuthenticated) {
      // Check for returnTo URL (e.g., from import flow) before defaulting to /home
      const returnTo = ImportSessionStorage.getAndClearReturnTo();
      navigate(returnTo || '/home', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return <>{children}</>;
};

export default AuthRoute;
